<template>
  <card v-if="report" :title="report.name" v-loading="loading[loadingKey]">
    <div v-if="error" class="error">{{ error }}</div>
    <chart :data="chartData" :type="report.chart_type" v-if="!collapsed" />
  </card>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapActions } from "vuex";
import Chart from "@/components/charts/Chart";
import Card from "@/components/Card";

export default {
  data() {
    return {
      chartData: {},
      error: "",
      collapsed: false,
    };
  },
  props: {
    report: Object,
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Chart,
    Card,
  },
  mounted() {
    if (this.report) this.getResults();
  },
  computed: {
    ...mapGetters(["loading"]),
    loadingKey() {
      const { id } = this.report;
      return `reportResults_${id}`;
    },
  },
  methods: {
    ...mapActions(["getReportResults"]),
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },
    extractParams({ period = "day", start, end }) {
      if (!start) start = moment().subtract(1, 'week').toDate();
      if (!end) end = moment().subtract(1, 'day').toDate();
      return { period, start, end };
    },
    async getResults() {
      try {
        const params = this.extractParams(this.params);
        const { id } = this.report;
        this.error = "";
        this.chartData = {};
        this.chartData = await this.getReportResults({ id, params });
      } catch (e) {
        this.error = "Failed fetching data for this chart :(";
        console.error(e);
      }
    },
  },
  watch: {
    report() {
      this.getResults();
    },
    params() {
      this.getResults();
    },
  },
};
</script>

<style scoped>
.collapse-button {
  cursor: pointer;
}
.error {
  text-align: center;
}
</style>
